import React, { useState } from 'react';
import { Container, Row, Col, Form, Table } from 'react-bootstrap';
import './App.css';
import { getRequestNoParams, postRequest } from './Services/HttpClient';

const GHIRupa = () => {
  const [poorva, setPoorva] = useState('');
  const [aagama, setAagama] = useState('');
  const [priority, setPriority] = useState('Poorva');
  const [paraData, setParaData] = useState(Array(24).fill(''));
  const [vibhaktisResult, setVibhaktisResult] = useState(null);
  const [error, setError] = useState(null);
  const [codeSnippet, setCodeSnippet] = useState('');

  const handlePoorvaChange = (e) => setPoorva(e.target.value);
  const handleAagamaChange = (e) => setAagama(e.target.value);
  const handlePriorityChange = (e) => setPriority(e.target.value);

  const handleParaChange = (index, value) => {
    const updatedParaData = [...paraData];
    updatedParaData[index] = value;
    setParaData(updatedParaData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
  
    const payload = { praatipadikam: poorva };
    console.log('Sending Payload:', payload);
  
    try {
      const response = await postRequest('getVibhaktis', JSON.stringify(payload), {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json(); 
      console.log('Parsed Response Data:', data);
      console.log('Vibhaktis Data:', data.data);
  
      if (data && data.data) {
        const resultArray = Object.values(data.data);  
        console.log('Result Array:', resultArray);
        setParaData(resultArray); 
      } else {
        throw new Error("Invalid response format");
      }
      
    } catch (err) {
      setError(err.message || "An error occurred");
    }
  };
  
  const handleRevealCode = async () => {
    setError(null);
    console.log("Requesting code snippet...");
  
    try {
      const response = await getRequestNoParams('getrupacode');
      console.log('Response received for code:', response); 
      let formattedCode = '';
      for (const [funcName, funcCode] of Object.entries(response)) {
        if (typeof funcCode === 'string') {
          formattedCode += `${funcName}:\n${funcCode.replace(/\\n/g, '\n')}\n\n`;
        } else {
          formattedCode += `${funcName}:\n[Non-string function source code]\n\n`;
        }
      }
  
      setCodeSnippet(formattedCode);
    } catch (err) {
      console.error("Error in handleRevealCode:", err);
      setError("Failed to fetch code");
    }
  };  
  

  return (
    <Container fluid="md">
      <Row className="text-center mb-4">
        <h2><strong>GHI RUPA</strong></h2>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <div>
            <h5 className='text-center'><strong>पूर्व - Poorva</strong></h5>
            <textarea
              value={poorva}
              rows="1"
              onChange={handlePoorvaChange}
              className="ghiRupa-textarea"
            />
          </div>
        </Col>
        <Col md={4}>
          <div>
            <h5 className='text-center'><strong>परा - Para</strong></h5>
            <div style={{ maxHeight: '155px', overflowY: 'auto', marginTop: '5px' }}>
              <Table bordered size="sm">
                <tbody>
                {paraData.length > 0 && paraData.map((data, index) => (
                  <tr key={index}>
                    <td>
                      <Form.Control
                        type="text"
                        value={data}
                        onChange={(e) => handleParaChange(index, e.target.value)}
                        style={{ textAlign: 'center',  fontSize: '1.4rem',   padding: '5px' }}
                      />
                    </td>
                  </tr>
                ))}
                </tbody>
              </Table>
            </div>
          </div>
        </Col>

        <Col md={4}>
          <div>
            <h5 className='text-center'><strong>आगमः - Aagama</strong></h5>
            <textarea
              value={aagama}
              rows="1"
              onChange={handleAagamaChange}
              className="ghiRupa-textarea"
            />
          </div>
        </Col>
      </Row>

      <Row className="mb-3 text-center">
        <h5 className='mt-4'><strong>Order of Priority:</strong></h5>
        <div className="d-flex justify-content-center mt-2">
          <Form.Check
            type="radio"
            label={<strong>1. पूर्व - Poorva</strong>}
            name="priority"
            value="Poorva"
            checked={priority === 'Poorva'}
            onChange={handlePriorityChange}
            className="krudantha-centered-text"
          />
          <Form.Check
            type="radio"
            label={<strong>2. परा - Para</strong>}
            name="priority"
            value="Para"
            checked={priority === 'Para'}
            onChange={handlePriorityChange}
            className="krudantha-centered-text mx-3"
          />
          <Form.Check
            type="radio"
            label={<strong>3. As Applicable</strong>}
            name="priority"
            value="Applicable"
            checked={priority === 'Applicable'}
            onChange={handlePriorityChange}
            className="krudantha-centered-text"
          />
        </div>
      </Row>

      <Row className="text-center mt-4">
        <Col>
          <button onClick={handleRevealCode} className="ghiRupa-button mx-2">Reveal Code</button>
          <button type="submit" onClick={handleSubmit}  className="ghiRupa-button mx-2">Reveal Form</button>
          <button className="ghiRupa-button mx-2">Reveal All</button>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <textarea
            value={codeSnippet}
            rows="10"
            readOnly
            className="ghiRupa-code-snippet"
            style={{ width: '100%', overflowY: 'auto', paddingLeft: '1rem'  }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default GHIRupa;
